/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import {useLoyaltyService} from "../../../services/loyaltyService";

/* Components */
import LoyaltyAtmBulkImportModal from "../../modals/loyaltyAtmBulkImportModal";
import { ReactComponent as UploadIcon } from "../../../resources/images/upload-icon-no-border.svg";
import { ReactComponent as DownloadIcon } from "../../../resources/images/download.svg";

/* Styles */
import styles from "./styles";
import UCButton from "../../buttons";


const AtmBulkImport = ({allotmentId, setAssignModalShow, onRedeemCompleted} ) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const { loyaltyAtmDownloadSample } = useLoyaltyService()

  const downloadCsv = async () => {
    const csv = await loyaltyAtmDownloadSample()

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "redemption_template.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [showAtmBulkImportModal, setShowAtmBulkImportModal] = useState(false)

  return (
    <div className={classes.mainDiv}>
      <div className={classes.bodyContainer}>
        <h6 className={classes.title}>
          <FormattedMessage id="loyalty.atmBulkImport.title"/>
        </h6>
        <p className={classes.secondaryText1}>
          <FormattedMessage id="loyalty.atmBulkImport.subtitle"/>
        </p>
        <hr className={classes.divider}/>
        <div className={classes.firstStepContainer}>
          <p className={classes.stepTitle}>
            <FormattedMessage id="loyalty.atmBulkImport.step1.title"/>
          </p>
          <UCButton
            onClick={() => downloadCsv()}
            type="default"
            className={classes.importBtn}
            text={<FormattedMessage id="loyalty.atmBulkImport.downloadBtnText"/>}
            iconEnd={<DownloadIcon/>}
            spinner={{
              name: "loyaltyAtmDownloadSpinner",
              size: 20,
            }}
            loadingStateStyling={classes.downloadBtnLoadingState}
          />
        </div>
        <div className={classes.firstStepContainer}>
          <p className={classes.stepTitle}>
            <FormattedMessage id="loyalty.atmBulkImport.step2.title"/>
          </p>
          <p className={classes.secondaryText2}>
            <FormattedMessage id="loyalty.atmBulkImport.step2.subtitle"/>
          </p>
        </div>
        <div>
          <ul className={classes.list}>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="loyalty.atmBulkImport.name"/>
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="loyalty.atmBulkImport.nameDescription"/>
              </p>
            </li>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="loyalty.atmBulkImport.masked"/>
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="loyalty.atmBulkImport.maskedDescription"/>
              </p>
            </li>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="loyalty.atmBulkImport.aaNumber"/>
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="loyalty.atmBulkImport.aaNumberDescription"/>
              </p>
            </li>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="loyalty.atmBulkImport.tier"/>
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="loyalty.atmBulkImport.tierDescription"/>
              </p>
            </li>
          </ul>

          <div className={classes.secondStepContainer}>
            <p className={classes.stepTitle}>
              <FormattedMessage id="loyalty.atmBulkImport.step3.title"/>
            </p>
            <p className={classes.secondaryText2}>
              <FormattedMessage id="loyalty.atmBulkImport.step3.subtitle"/>
            </p>
          </div>
          <UCButton
            onClick={() => setShowAtmBulkImportModal(true)}
            type="default"
            className={classes.importBtn}
            text={<FormattedMessage id="loyalty.atmBulkImport.btnText"/>}
            iconEnd={<UploadIcon/>}
          />
        </div>
      </div>
      <LoyaltyAtmBulkImportModal
        showAtmBulkImportModal={showAtmBulkImportModal}
        allotmentId={allotmentId}
        setShowAtmBulkImportModal={setShowAtmBulkImportModal}
        setAssignModalShow={setAssignModalShow}
        onRedeemCompleted={onRedeemCompleted}
      />
    </div>
  );
};

export default AtmBulkImport;
